import {
  Headset, Target, Megaphone, PenNib, ChartLineUp, Scales, GraduationCap, UsersThree, ShoppingCart, ShieldCheck,
  Lightning, Sparkle, Envelope, Notebook, ListChecks, MagnifyingGlass, Calculator, Code, Translate, SealCheck,
  Robot, Brain, Cpu, House, Heartbeat, Briefcase, Rocket, ChatCircleText, Atom, Compass, Database, Leaf,
  Bank, Coins, Buildings, Key, PiggyBank, Receipt,
} from "@phosphor-icons/react";

export const ICONS = {
  Robot, Brain, Cpu, Sparkle, Headset, Target, Megaphone, PenNib, ChartLineUp, Scales, GraduationCap, UsersThree,
  ShoppingCart, ShieldCheck, Lightning, Envelope, Notebook, ListChecks, MagnifyingGlass, Calculator, Code, Translate,
  SealCheck, House, Heartbeat, Briefcase, Rocket, ChatCircleText, Atom, Compass, Database, Leaf,
  Bank, Coins, Buildings, Key, PiggyBank, Receipt,
};

export const AGENT_ICONS = Object.keys(ICONS);
export const COLORS = ["#2563EB", "#22D3EE", "#10B981", "#A3E635", "#F59E0B", "#F97316", "#EF4444", "#E11D48", "#FFFFFF"];

export const Icon = ({ name, ...props }) => {
  const C = ICONS[name] || Robot;
  return <C {...props} />;
};
